import React, { useEffect, useRef, useState } from "react";
import "../dashboard.scss";
import { AgGridReact } from "ag-grid-react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import { academylist, listvehicle, vehicledelete } from "../../../services/admin";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export default function Vehiclelist() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0], path);
              }
            }

          }
        }
      });
    } else {
      listall("", path)
    }
  }, [location.pathname]);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, urllink)
    } else {
      setAcaID("");
      listall("", urllink);
    }
  }

  function listall(aid, atype) {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    if (atype == "deletevehiclelist") {
      temp.append("status", 0);
    } else {
      temp.append("status", 1);
    }

    listvehicle(temp).then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data.details);
      }
    })
  }

  function vehdelete(vid) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        vehicledelete(vid).then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            navigate("/transport/deletevehiclelist");

          }
        });
      }
    });
  }

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      suppressCsvExport: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/transport/vehicledetail/${params.value}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a onClick={() => vehdelete(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },

    {
      headerName: "Driver",
      field: "worker_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Number",
      field: "vehicle_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Registration Number",
      field: "reg_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "RC Number",
      field: "rc_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Chasis Number",
      field: "chasis_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Type",
      field: "vehtype_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Route",
      field: "vehroute_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Trip",
      field: "vehtrip_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Certificate Number",
      field: "certificate_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Insurance Number",
      field: "insurance_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Registrated Date",
      field: "reg_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Registrated Renewal",
      field: "reg_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Tax Start Date",
      field: "tax_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Tax Renewal Date",
      field: "tax_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "POC Start Date",
      field: "pos_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "POS Renewal Date",
      field: "pos_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Insurance Start Date",
      field: "ins_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Insurance Renewal Date",
      field: "ins_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
  ];

  const columnDDefs = [

    {
      headerName: "Driver",
      field: "worker_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Number",
      field: "vehicle_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Registration Number",
      field: "reg_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "RC Number",
      field: "rc_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Chasis Number",
      field: "chasis_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Type",
      field: "vehtype_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Vehicle Route",
      field: "vehroute_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Trip",
      field: "vehtrip_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Certificate Number",
      field: "certificate_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Insurance Number",
      field: "insurance_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Registrated Date",
      field: "reg_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Registrated Renewal",
      field: "reg_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Tax Start Date",
      field: "tax_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Tax Renewal Date",
      field: "tax_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "POC Start Date",
      field: "pos_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "POS Renewal Date",
      field: "pos_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Insurance Start Date",
      field: "ins_start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
    {
      headerName: "Insurance Renewal Date",
      field: "ins_renewal_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            {moment(params.value).format("DD-MM-YYYY")}
          </div>
        );
      }
    },
  ];
  const gridRef = useRef();

  function handleExport() {
    const exportColumns = gridRef.current.columnApi
      .getAllGridColumns()
      .filter(col => !col.getColDef().suppressCsvExport) // ✅ only include non-suppressed columns
      .map(col => col.getColId());

    gridRef.current.api.exportDataAsCsv({
      fileName: 'Vehicle List.csv',
      columnKeys: exportColumns
    });
  }

  return (
    <div>
      <div className="page-header">
        {urllink === "deletevehiclelist" &&
          <h2 className="main-content-title tx-24 mg-b-5"> Delete Vehicle List</h2>

        }
        {urllink === "vehiclelist" &&
          <h2 className="main-content-title tx-24 mg-b-5"> Vehicle List</h2>

        }
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Transport Module</a>
          </li>
          {urllink === "deletevehiclelist" &&
            <li className="breadcrumb-item active" aria-current="page">
              Delete Vehicle List
            </li>
          }
          {urllink === "vehiclelist" &&
            <li className="breadcrumb-item active" aria-current="page">
              Vehicle List
            </li>
          }

        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={alist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />

                    </div>
                  </div>
                )}
                {urllink == "vehiclelist" && (
                  <div className={localStorage.getItem("Role") === "1" ? "col-xl-6 col-sm-6" : "col-xl-12 col-sm-6"}>
                    <div className="res-right">
                      <button className="btn btn-success mt-5" onClick={handleExport}>
                        Excel Download
                      </button>

                    </div>
                  </div>
                )}
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                {(localStorage.getItem("Role") === "1" || localStorage.getItem("Role") === "2") ? (
                  <AgGridReact
                    ref={gridRef}
                    columnDefs={urllink === "deletevehiclelist" ? columnDDefs : columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                ) : (
                  <AgGridReact
                    ref={gridRef}
                    columnDefs={columnDDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                )

                }

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
